import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { toFormData } from '../../utils/toFormData';
import { logError } from '../../utils/logError';
import { formatErrorKeys } from '../formatErrorKeys';
import { CreateSocialUserPayload, CreateSocialUserResponse } from './createSocialUser.types';

export const createSocialUser = async ({ email, username, funnel }: CreateSocialUserPayload) => {
    try {
        const url = pathfinder('create_social_user_users');
        const formData = toFormData({
            'user[email]': email,
            'user[username]': username,
            funnel,
            redirect_url: undefined,
        });

        const { data } = await axios.post<CreateSocialUserResponse>(url, formData);
        const formattedErrors = formatErrorKeys(data.error_keys || []);

        return {
            redirectUrl: data.redirect_url,
            errorKeys: formattedErrors,
            externalId: data.external_id,
        };
    } catch (error) {
        logError({
            message: 'Error during create social user',
            error,
        });

        throw error;
    }
};
